<div class="header">
    <div class="container-fluid">
        <div class="header-body">
            <div class="row align-items-end g-3">
                <div class="col">
                    <h6 class="header-pretitle">Overview</h6>
                    <ng-container *ngIf="dashboard.info.name else titleBasedOnSources">
                        <h1 class="header-title notranslate">
                            Dashboard {{ dashboard.info.name ? '- ' + dashboard.info.name : "" }}
                        </h1>
                    </ng-container>
                    <ng-template #titleBasedOnSources>
                        <ng-container *ngIf="headerTitle else defaultTitle">
                            <h1 class="header-title notranslate">
                                {{headerTitle | middleEllipsis: 40}}
                            </h1>
                        </ng-container>
                        <ng-template #defaultTitle>
                            <h1 class="header-title notranslate">Dashboard</h1>
                        </ng-template>
                    </ng-template>
                </div>
                <div class="col-auto">
                    <app-confirmation-toggle *ngIf="dashboard?.dashboardId">
                        <div class="btn btn-outline-danger">Delete</div>
                        <div class="modal-content">
                            <div class="modal-card card">
                                <div class="card-header">
                                    <h4 class="card-header-title">Delete dashboard?</h4>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                </div>
                                <div class="card-body">
                                    <p>Are you sure you want to delete this dashboard?</p>
                                </div>
                                <div class="card-footer d-flex justify-content-between">
                                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                    <button type="button" class="btn btn-danger"
                                            (click)="deleteDashboard(dashboard.dashboardId)" data-bs-dismiss="modal">
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </app-confirmation-toggle>
                </div>
                <div class="col-auto" *ngIf="!showPerformanceByMeter">
                    <div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                            <i class="bi bi-download me-md-2"></i>
                            <span class="d-none d-md-inline">Download</span>
                        </button>
                        <ul class="dropdown-menu" style="z-index: 10000">
                            <li>
                                <button class="dropdown-item" (click)="downloadMonthlyData()">
                                    Monthly measurement data
                                </button>
                            </li>
                            <li>
                                <button class="dropdown-item" (click)="downloadDetailedMonthlyData()">Monthly measurement data (detailed)
                                </button>
                            </li>
                            <li *ngIf="hasSubmeterData">
                                <button class="dropdown-item" (click)="downloadMonthlySubmeterData()">
                                    Monthly submeter data
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="btn btn-primary" (click)="openModal(saveDashboardModal)">Save dashboard</div>

                    <div class="btn btn-outline-primary rounded-top ms-4 d-none">
                        <i class="bi bi-pencil-fill pe-sm-2"></i>
                        <span class="d-none d-sm-inline-block">Customize</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-measurements-handler [data]="measurementsHandlerData">
    <div>
        <div class="container-fluid sticky-md-top bg-body" style="z-index: 1050">
            <div class="row justify-content-between py-4">
                <div class="col-12 col-sm">
                    <app-sources-selector [sourceProvider]="sourceProvider"></app-sources-selector>
                </div>
                <div class="col-12 col-sm-auto d-flex justify-content-end mt-4 mt-sm-0">
                    <app-data-provider-date-range></app-data-provider-date-range>
                </div>
            </div>
        </div>
        <div (change)="updateAndNavigateToDashboard()" class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <app-energy-summary-widget></app-energy-summary-widget>
                </div>
            </div>
            <div *ngIf="locationEntity" class="row">
                <div class="col-12 col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1"
                         style="background-image: url('assets/images/building-background-v3.jpg');
                             background-repeat: no-repeat; background-size: contain; background-position: center; min-height: 350px">
                    </div>
                </div>
                <div class="col-12 col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-body">
                            <app-location-energy-label-info [location]="locationEntity.location"></app-location-energy-label-info>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="locationEntity" class="row">
                <div class="col-12 col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-body">
                            <app-location-meters [location]="locationEntity"></app-location-meters>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-header">
                            <h4 class="card-header-title">
                                <img src="assets/images/icons/environmentalism.png" width="20px" class="me-2">
                                Energy compass
                            </h4>
                        </div>
                        <div class="card-body d-flex flex-grow-1">
                            <app-location-energy-compass [location]="locationEntity.location"
                                                         class="d-flex flex-grow-1"></app-location-energy-compass>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()">
                <app-meter-tree-view *ngIf="locationEntity" class="flex-fill"></app-meter-tree-view>
            </div>
            <div class="row row-medium">
                <div class="col-12 d-flex align-items-stretch" [ngClass]="showPerformanceByMeter ? 'col-md-6' : 'col-md-8'">
                    <app-meter-performance-chart *ngIf="!isPortfolio || showPerformanceByMeter else locationPerformanceChart" class="d-flex align-self-stretch flex-grow-1"></app-meter-performance-chart>
                    <ng-template #locationPerformanceChart>
                        <app-location-performance-chart *ngIf="!showPerformanceByMeter" class="d-flex align-self-stretch flex-grow-1"></app-location-performance-chart>
                    </ng-template>
                </div>
                <div class="col-6 d-flex align-items-stretch" *ngIf="showPerformanceByMeter">
                    <app-electricity-chart class="d-flex align-self-stretch flex-grow-1"></app-electricity-chart>
                </div>
                <div class="col-4" *ngIf="!showPerformanceByMeter">
                    <div class="row h-100">
                        <div class="col d-flex align-items-stretch">
                            <app-costs-chart *ngIf="!isPortfolio else dashboardMaps" class="card d-flex align-self-stretch flex-grow-1"></app-costs-chart>
                            <ng-template #dashboardMaps>
                                <div class="card w-100" style="overflow: auto">
                                    <div class="card-body p-0" style="max-height: none">
                                        <app-dashboard-maps [locations]="addresses"></app-dashboard-maps>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!showPerformanceByMeter">
                <div class="col-12 col-md-8">
                    <app-electricity-chart class="chart"></app-electricity-chart>
                </div>
                <div class="col-12 col-md-4 d-flex align-items-stretch">
                    <app-costs-chart *ngIf="isPortfolio else co2Chart" class="card d-flex align-self-stretch flex-grow-1"></app-costs-chart>
                    <ng-template #co2Chart>
                        <app-co2-chart class="card d-flex align-self-stretch flex-grow-1"></app-co2-chart>
                    </ng-template>
                </div>
            </div>
            <div class="row">
                <div #gasChartContainer class="col-12 col-md-6">
                    <ng-container *ngIf="!chartVisibility['gas']; else gasChart">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #gasChart>
                        <app-gas-chart class="chart"></app-gas-chart>
                    </ng-template>
                </div>
                <div #waterChartContainer class="col-12 col-md-6">
                    <ng-container *ngIf="!chartVisibility['water']; else waterChart">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #waterChart>
                        <app-water-chart class="chart"></app-water-chart>
                    </ng-template>
                </div>
            </div>
            <div *ngIf="isPortfolio && !showPerformanceByMeter" class="row row-large">
                <div #energyCompassChartContainer class="col-12 col-md-8">
                    <ng-container *ngIf="!chartVisibility['energyCompass']; else energyCompassChart">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #energyCompassChart>
                        <app-energy-compass-chart *ngIf="isPortfolio"></app-energy-compass-chart>
                    </ng-template>
                </div>
                <div #co2ChartContainer class="col-12 col-md-4 d-flex align-items-stretch">
                    <div *ngIf="!chartVisibility['co2']; else co2Chart" class="flex-fill pb-3">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </div>
                    <ng-template #co2Chart>
                        <app-co2-chart class="card d-flex align-self-stretch flex-grow-1"></app-co2-chart>
                    </ng-template>
                </div>
            </div>
            <div class="row">
                <div #chargePointChartContainer class="col-12 col-md-6">
                    <ng-container *ngIf="!chartVisibility['chargePoint']; else chargepointChart">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #chargepointChart>
                        <app-chargepoint-chart class="chart"></app-chargepoint-chart>
                    </ng-template>
                </div>
                <div #dayOfWeekChartContainer class="col-12 col-md-6">
                    <ng-container *ngIf="!chartVisibility['dayOfWeek']; else dayOfWeekChart">
                        <ngx-skeleton-loader count="1" [appearance]="'line'"
                                             [theme]="{ height: '350px', 'border-radius': '0.25rem' }">
                        </ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #dayOfWeekChart>
                        <app-day-of-week-chart class="d-flex align-self-stretch flex-grow-1"></app-day-of-week-chart>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</app-measurements-handler>

<ng-template #saveDashboardModal>
    <app-form (submit)="saveDashboard()">
        <div class="modal-content">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-header-title">Save dashboard</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="card-body">
                    <div class="mb-3">
                        <label for="dashboardName" class="form-label">Name</label>
                        <input type="text" [(ngModel)]="dashboard.info.name" name="dashboardName"
                               class="form-control" id="dashboardName">
                    </div>
                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-between">
                        <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                        <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </app-form>
</ng-template>